import { db } from '../config/firebase';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { QUOTA_CONFIG } from '../config/constants';

export const initializeUserQuota = async (userId, email) => {
  const userQuotaRef = doc(db, 'userQuotas', userId);
  const quotaDoc = await getDoc(userQuotaRef);

  if (!quotaDoc.exists()) {
    await setDoc(userQuotaRef, {
      totalCharsLimit: QUOTA_CONFIG.FREE_TIER_CHARS,
      usedChars: 0,
      email,
      premium: 'expired'
    });
  }
  return userQuotaRef;
};

export const checkAndUpdateQuota = async (userId, charCount) => {
  const userQuotaRef = doc(db, 'userQuotas', userId);
  const quotaDoc = await getDoc(userQuotaRef);
  
  if (!quotaDoc.exists()) {
    throw new Error('User quota not initialized');
  }

  const { usedChars, totalCharsLimit } = quotaDoc.data();
  const remainingChars = totalCharsLimit - usedChars;

  if (charCount > remainingChars) {
    return {
      canProceed: false,
      remainingChars,
      totalCharsLimit
    };
  }

  await updateDoc(userQuotaRef, {
    usedChars: usedChars + charCount
  });

  return {
    canProceed: true,
    remainingChars: remainingChars - charCount,
    totalCharsLimit
  };
};

export const getQuotaStatus = async (userId) => {
  const userQuotaRef = doc(db, 'userQuotas', userId);
  const quotaDoc = await getDoc(userQuotaRef);

  if (!quotaDoc.exists()) {
    return null;
  }

  const { usedChars, totalCharsLimit, premium } = quotaDoc.data();
  return {
    usedChars,
    remainingChars: totalCharsLimit - usedChars,
    totalCharsLimit,
    premium
  };
};